import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Step from '@/components/Step/Step';
import { ActionTypes, GetterTypes } from '@/store-vuex/types';
import { isFirstAptAllowed, isRadiologueChoiceActivatedFromSU, isRdvLongUsedFromSU } from '@/config/app.config';
import ParticipantService from '@/services/participant.service';

@Component({
  components: {
    Step,
  },
})
export default class Stepper extends Vue {
  @Prop()
  public selectedStepNumber!: number;
  @Prop()
  public maxVisitedStepNumber!: number;

  public get useTRMGenderChoice(): boolean {
    return this.$store.getters[GetterTypes.useTRMGenderChoice];
  }

  public get useLongAppointment(): boolean {
    return this.$store.getters[GetterTypes.useLongAppointment];
  }

  public get allowFirstAppointment(): boolean {
    return this.$store.getters[GetterTypes.allowFirstAppointment];
  }

  public get isParticipantFirstAppointment(): boolean {
    return this.$store.getters[GetterTypes.isFirstAppointment];
  }

  public get showFirstAppointmentNotAllowed(): boolean {
    return !this.allowFirstAppointment && this.isParticipantFirstAppointment;
  }

  public get showFirstStep(): boolean {
    return this.useTRMGenderChoice || this.useLongAppointment || this.showFirstAppointmentNotAllowed;
  }

  public isSelected(step: number): boolean {
    return this.selectedStepNumber === step;
  }

  public isPassed(step: number): boolean {
    return this.selectedStepNumber > step;
  }

  public isJumpable(step: number): boolean {
    return this.maxVisitedStepNumber >= step;
  }

  public onUpdateSelectedStepNumber(step: number): void {
    this.$emit('update-current-step-number', step);
  }

  @Watch('maxVisitedStepNumber')
  protected onMaxVisitedStepNumber(value: number, oldValue: number) {
    if (oldValue !== value) {
      if (value !== undefined) {
        this.$store.dispatch(ActionTypes.setMaxVisitedStepNumber, value);
      }
    }
  }
}
